<template>
  <span class="label" :class="{'required': isRequired && !woLabel}">
    <slot>{{ label }}</slot>
    <a
      v-if="labelLinkText && labelLinkUrl"
      :href="labelLinkUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="label-link"
    >{{ labelLinkText }}</a>
  </span>
</template>

<script>
export default {
  name: 'FieldLabel',
  props: {
    label: { type: String, default: '' },
    isRequired: { type: Boolean, default: false },
    woLabel: { type: Boolean, default: false },
    labelLinkText: { type: String, default: null },
    labelLinkUrl: { type: String, default: null }
  }
}
</script>

<style scoped>
.label-link {
  margin-left: 6px;
  font-size: 0.85em;
  color: #2563eb;
  text-decoration: underline;
  cursor: pointer;
}
.label-link:hover {
  color: #1d4ed8;
}
</style>
